export const ladderPlaceholders = {
	Euro: {
		rounds: {
			'Round of 16': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy B",
						"top_team": 'Hiszpania',
						"localteam_team_query_name": 'spain',
						"bottom_text": "3. drużyna grup A/D/E/F",
						"bottom_team": 'Gruzja',
						'visitorteam_team_query_name': 'georgia',
						"date": '30.06 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy A",
						"top_team": 'Niemcy',
						"localteam_team_query_name": 'germany',
						"bottom_text": "2. drużyna grupy C",
						"bottom_team": 'Dania',
						'visitorteam_team_query_name': 'denmark',
						"date": '29.06 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy F",
						"top_team": 'Portugalia',
						"localteam_team_query_name": 'portugal',
						"bottom_text": "3. drużyna grup A/B/C",
						"bottom_team": 'Słowenia',
						'visitorteam_team_query_name': 'slovenia',
						"date": '01.07 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "2. drużyna grupy D",
						"top_team": 'Francja',
						"localteam_team_query_name": 'france',
						"bottom_text": "2. drużyna grupy E",
						"bottom_team": 'Belgia',
						'visitorteam_team_query_name': 'belgium',
						"date": '01.07 18:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy E",
						"top_team": 'Rumunia',
						"localteam_team_query_name": 'romania',
						"bottom_text": "3. drużyna grup A/B/C/D",
						"bottom_team": 'Holandia',
						'visitorteam_team_query_name': 'netherlands',
						"date": '02.07 18:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy D",
						"top_team": 'Austria',
						"localteam_team_query_name": 'austria',
						"bottom_text": "2. drużyna grupy F",
						"bottom_team": 'Turcja',
						'visitorteam_team_query_name': 'turkey',
						"date": '02.07 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy C",
						"top_team": 'Anglia',
						"localteam_team_query_name": 'england',
						"bottom_text": "3. drużyna grup D/E/F",
						"bottom_team": 'Słowacja',
						'visitorteam_team_query_name': 'slovakia',
						"date": '30.06 18:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "2. drużyna grupy A",
						"top_team": 'Szwajcaria',
						"localteam_team_query_name": 'switzerland',
						"bottom_text": "2. drużyna grupy B",
						"bottom_team": 'Włochy',
						'visitorteam_team_query_name': 'italy',
						"date": '29.06 18:00'
					},
				]
			},
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Hiszpania',
						"localteam_team_query_name": 'spain',
						"bottom_text": "-",
						"bottom_team": 'Niemcy',
						"visitorteam_team_query_name": 'germany',
						"date": '05.07 18:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Portugalia',
						"localteam_team_query_name": 'portugal',
						"bottom_text": "-",
						"bottom_team": 'Francja',
						'visitorteam_team_query_name': 'france',
						"date": '05.07 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Holandia',
						"localteam_team_query_name": 'netherlands',
						"bottom_text": "-",
						"bottom_team": 'Turcja',
						'visitorteam_team_query_name': 'turkey',
						"date": '06.07 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Anglia',
						"localteam_team_query_name": 'england',
						"bottom_text": "-",
						"bottom_team": 'Szwajcaria',
						'visitorteam_team_query_name': 'switzerland',
						"date": '06.07 18:00'
					},
				]
			},
			'Semi-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Hiszpania',
						"localteam_team_query_name": 'spain',
						"bottom_text": "-",
						"bottom_team": 'Francja',
						'visitorteam_team_query_name': 'france',
						"date": '09.07 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Anglia',
						"localteam_team_query_name": 'england',
						"bottom_text": "-",
						"bottom_team": 'Holandia',
						'visitorteam_team_query_name': 'netherlands',
						"date": '10.07 21:00'
					},
				]
			},
			'Final': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Hiszpania',
						"localteam_team_query_name": 'spain',
						"bottom_text": "-",
						"bottom_team": 'Anglia',
						'visitorteam_team_query_name': 'england',
						"date": '14.07 21:00'
					},
				]
			},
		}
	},
	Copa: {
		rounds: {
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy A",
						"top_team": 'Argentyna',
						"localteam_team_query_name": 'argentina',
						"bottom_text": "2. drużyna grupy B",
						"bottom_team": 'Ekwador',
						'visitorteam_team_query_name': 'ecuador',
						"date": '05.07 03:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy B",
						"top_team": 'Wenezuela',
						"localteam_team_query_name": 'venezuela',
						"bottom_text": "2. drużyna grupy A",
						"bottom_team": 'Kanada',
						'visitorteam_team_query_name': 'canada',
						"date": '06.07 03:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy C",
						"top_team": 'Urugwaj',
						"localteam_team_query_name": 'uruguay',
						"bottom_text": "2. drużyna grupy D",
						"bottom_team": 'Brazylia',
						'visitorteam_team_query_name': 'brazil',
						"date": '07.07 03:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy D",
						"top_team": 'Kolumbia',
						"localteam_team_query_name": 'colombia',
						"bottom_text": "2. drużyna grupy C",
						"bottom_team": 'Panama',
						'visitorteam_team_query_name': 'panama',
						"date": '07.07 00:00'
					},
				]
			},
			'Semi-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Urugwaj',
						"localteam_team_query_name": 'uruguay',
						"bottom_text": "-",
						"bottom_team": 'Kolumbia',
						'visitorteam_team_query_name': 'colombia',
						"date": '10.07 02:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Argentyna',
						"localteam_team_query_name": 'argentina',
						"bottom_text": "-",
						"bottom_team": 'Kanada',
						'visitorteam_team_query_name': 'canada',
						"date": '11.07 02:00'
					},
				]
			},
			'Final': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Kolumbia',
						"localteam_team_query_name": 'colombia',
						"bottom_text": "-",
						"bottom_team": 'Argentyna',
						'visitorteam_team_query_name': 'argentina',
						"date": '15.07 02:00'
					},
				],
				third_place: {
					"status": "PLACEHOLDER",
					"top_text": "-",
					"top_team": 'Urugwaj',
					"localteam_team_query_name": 'uruguay',
					"bottom_text": "-",
					"bottom_team": 'Kanada',
					'visitorteam_team_query_name': 'canada',
					"date": '14.07 02:00'
				}
			},
		}
	},
	OL: {
		rounds: {
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy A",
						"top_team": 'Francja OL',
						"localteam_team_query_name": 'francja-ol',
						"bottom_text": "2. drużyna grupy B",
						"bottom_team": 'Argentyna OL',
						'visitorteam_team_query_name': 'argentyna-ol',
						"date": '02.08 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy C",
						"top_team": 'Egipt OL',
						"localteam_team_query_name": 'egipt-ol',
						"bottom_text": "2. drużyna grupy D",
						"bottom_team": 'Paragwaj OL',
						'visitorteam_team_query_name': 'paragwaj-ol',
						"date": '02.08 19:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy B",
						"top_team": 'Maroko OL',
						"localteam_team_query_name": 'maroko-ol',
						"bottom_text": "2. drużyna grupy A",
						"bottom_team": 'USA OL',
						'visitorteam_team_query_name': 'stany-zjednoczone-ol',
						"date": '02.08 15:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy D",
						"top_team": 'Japonia OL',
						"localteam_team_query_name": 'japonia-ol',
						"bottom_text": "2. drużyna grupy C",
						"bottom_team": 'Hiszpania OL',
						'visitorteam_team_query_name': 'hiszpania-ol',
						"date": '02.08 17:00'
					},
				]
			},
			'Semi-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Francja OL',
						"localteam_team_query_name": 'francja-ol',
						"bottom_text": "-",
						"bottom_team": 'Egipt OL',
						'visitorteam_team_query_name': 'egipt-ol',
						"date": '05.08 18:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Maroko OL',
						"localteam_team_query_name": 'maroko-ol',
						"bottom_text": "-",
						"bottom_team": 'Hiszpania OL',
						'visitorteam_team_query_name': 'hiszpania-ol',
						"date": '05.08 21:00'
					},
				]
			},
			'Final': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": 'Francja OL',
						"localteam_team_query_name": 'francja-ol',
						"bottom_text": "-",
						"bottom_team": 'Hiszpania OL',
						'visitorteam_team_query_name': 'hiszpania-ol',
						"date": '08.08 17:00'
					},
				],
				third_place: {
					"status": "PLACEHOLDER",
					"top_text": "-",
					"top_team": 'Egipt OL',
					"localteam_team_query_name": 'egipt-ol',
					"bottom_text": "-",
					"bottom_team": 'Maroko OL',
					'visitorteam_team_query_name': 'maroko-ol',
					"date": '08.09 18:00'
				}
			},
		}
	},
	LM: {
		rounds: {
			'Knockout Round Play-offs': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'juventus',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'psv',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'arsenal',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'manchester-city',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'real-madryt',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'atl-madryt',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'brest',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'psg',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'liverpool',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'club-brugge',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'atalanta',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'aston-villa',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'monaco',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'benfica',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'barcelona',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'sporting',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'borussia-dortmund',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'lille',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'celtic',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'bayern',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'leverkusen',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'feyenoord',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'ac-milan',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'inter',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
				]
			},
			'Round of 16': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'psv',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'arsenal',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'real-madryt',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'atl-madryt',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'psg',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'liverpool',
						"date": '05.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'club-brugge',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'aston-villa',
						"date": ''
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'benfica',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'barcelona',
						"date": ''
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'borussia-dortmund',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'lille',
						"date": ''
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'bayern',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'leverkusen',
						"date": '05.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'feyenoord',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'inter',
						"date": '05.03 18:45'
					},
				]
			},
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": 'arsenal',
						"bottom_text": "-",
						"bottom_team": '',
						"visitorteam_team_query_name": 'real-madryt',
						"date": '08.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": 'psg',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': 'aston-villa',
						"date": '09.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": 'barcelona',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': 'borussia-dortmund',
						"date": '08.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": 'bayern',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': 'inter',
						"date": '09.04 21:00'
					},
				]
			},
			'Semi-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						"visitorteam_team_query_name": '',
						"date": '29.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '29.04 21:00'
					},
				]
			},
		}
	},
	LE: {
		rounds: {
			'Knockout Round Play-offs': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'az-alkmaar',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'galatasaray',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'tottenham',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'royale-union-sg',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'ajax',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'eintracht-frankfurt',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'twente',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'bodoglimt',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'olympiakos',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'ferencvaros',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'pilzno',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'lazio',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fenerbahce',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'anderlecht',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'rangers',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fc-porto',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'as-roma',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'ath-bilbao',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'paok',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'fcsb',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'lyon',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'midtjylland',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'real-sociedad',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'manchester-utd',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
				]
			},
			'Round of 16': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'az-alkmaar',
						"bottom_text": "",
						"bottom_team": 'Tottenham',
						'visitorteam_team_query_name': 'tottenham',
						"date": '06.03 18:45'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'ajax',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'eintracht-frankfurt',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'bodoglimt',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'olympiakos',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'pilzno',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'lazio',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fenerbahce',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'rangers',
						"date": '06.03 18:45'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'as-roma',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'ath-bilbao',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fcsb',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'lyon',
						"date": '06.03 18:45'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'real-sociedad',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'manchester-utd',
						"date": '06.03 18:45'
					},
				]
			},
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						"visitorteam_team_query_name": '',
						"date": '10.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '10.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '10.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '10.04 21:00'
					},
				]
			},
		}
	},
	LKE: {
		rounds: {
			'Knockout Round Play-offs': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'gent',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'betis',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'guimaraes',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'backa-topola',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'jagiellonia',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'cercle-brugge',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'celje',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'apoel',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'lugano',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'vikingur-r',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'panathinaikos',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fiorentina',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fc-kopenhaga',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'heidenheim',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'chelsea',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'molde',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'shamrock-rovers',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'legia-w',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'omonia',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'paphos',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'djurgardens',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'borac-banja-luka',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'o-ljubljana',
						"date": '04.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'rapid-wieden',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '04.03 21:00'
					},
				]
			},
			'Round of 16': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'betis',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'guimaraes',
						"date": '06.03 18:45'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'jagiellonia',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'cercle-brugge',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'celje',
						"bottom_text": "",
						"bottom_team": 'Lugano',
						'visitorteam_team_query_name': 'lugano',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'panathinaikos',
						"bottom_text": "",
						"bottom_team": 'Fiorentina',
						'visitorteam_team_query_name': 'fiorentina',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'fc-kopenhaga',
						"bottom_text": "",
						"bottom_team": 'Chelsea',
						'visitorteam_team_query_name': 'chelsea',
						"date": '06.03 18:45'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'molde',
						"bottom_text": "",
						"bottom_team": 'Legia W.',
						'visitorteam_team_query_name': 'legia-w',
						"date": '06.03 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'paphos',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'djurgardens',
						"date": '06.03 18:45'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": '',
						"localteam_team_query_name": 'borac-banja-luka',
						"bottom_text": "",
						"bottom_team": '',
						'visitorteam_team_query_name': 'rapid-wieden',
						"date": '06.03 18:45'
					},
				]
			},
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						"visitorteam_team_query_name": '',
						"date": '10.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '10.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '10.04 21:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '10.04 21:00'
					},
				]
			},
		}
	},
	LN: {
		rounds: {
			'3rd Place Final': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "",
						"top_team": 'Francja',
						"localteam_team_query_name": 'francja',
						"bottom_text": "",
						"bottom_team": 'Niemcy',
						'visitorteam_team_query_name': 'niemcy',
						"date": ''
					}
				]
			}
		}
	},
	GC: {
		rounds: {
			'Quarter-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy D",
						"top_team": 'USA',
						"localteam_team_query_name": 'usa',
						"bottom_text": "2. drużyna grupy A",
						"bottom_team": 'Kostaryka',
						'visitorteam_team_query_name': 'kostaryka',
						"date": '29.06 01:15'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy B",
						"top_team": 'Kanada',
						"localteam_team_query_name": 'kanada',
						"bottom_text": "2. drużyna grupy C",
						"bottom_team": 'Gwatemala',
						'visitorteam_team_query_name': 'gwatemala',
						"date": '29.06 22:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy A",
						"top_team": 'Meksyk',
						"localteam_team_query_name": 'meksyk',
						"bottom_text": "2. drużyna grupy D",
						"bottom_team": 'Arabia Saudyjska',
						'visitorteam_team_query_name': 'arabia-saudyjska',
						"date": '29.06 04:15'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "Zwycięzca grupy C",
						"top_team": 'Panama',
						"localteam_team_query_name": 'panama',
						"bottom_text": "2. drużyna grupy B",
						"bottom_team": 'Honduras',
						'visitorteam_team_query_name': 'honduras',
						"date": '29.06 01:15'
					},
				]
			},
			'Semi-finals': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '02.07 22:00'
					},
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '02.07 22:00'
					},
				]
			},
			'Final': {
				round_matches: [
					{
						"status": "PLACEHOLDER",
						"top_text": "-",
						"top_team": '',
						"localteam_team_query_name": '',
						"bottom_text": "-",
						"bottom_team": '',
						'visitorteam_team_query_name': '',
						"date": '06.07 22:00'
					},
				],
			}
		}
	}
}